"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * French localization
 */
exports.default = {
    /**
     * Welcome page
     */
    skip: 'Passer',
    letsStart: 'Commencer',
    next: 'Suivant',
    registerNow: "S'inscrire maintenant",
    welcome_title_1: 'Découvrez le premier portefeuille basé sur les NFT',
    welcome_subtitle_1: 'Achetez, collectionnez et échangez des objets',
    welcome_title_2: 'Créez votre propre collection de NFT dès maintenant',
    welcome_subtitle_2: 'Achetez, collectionnez et échangez des objets',
    welcome_title_3: 'Découvrez le monde passionnant de la crypto',
    welcome_subtitle_3: 'Achetez, collectionnez et échangez des objets',
    /**
     * Login and registration page
     */
    login: 'Connexion',
    welcomeBack: 'Bienvenue de nouveau, vous nous avez manqué !',
    noAccount: "Vous n'avez pas de compte ?",
    register: "S'inscrire",
    offline: 'Vous semblez être hors ligne !',
    checkConnection: 'Vérifiez votre connexion et réessayez',
    username: "Nom d'utilisateur",
    usernameOrEmail: "Nom d'utilisateur ou Email",
    usernameRequired: "Le nom d'utilisateur est requis *",
    password: 'Mot de passe',
    passwordErrorLength: 'Doit contenir au moins 8 caractères',
    forgotPassword: 'Mot de passe oublié ?',
    byClickingRegister: "En cliquant sur S'inscrire, vous acceptez notre",
    privacyNotice: 'Avis de confidentialité',
    termsAndConditions: 'Conditions générales.',
    and: 'et',
    accountRemoved: 'Compte Supprimé',
    accountRemovedMessage: 'Votre compte a été supprimé avec succès.',
    /**
     * Reset Password page
     */
    resetPassword: 'Réinitialiser le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmez le nouveau mot de passe',
    emailSent: 'Email envoyé avec succès !',
    passwordChanged: 'Mot de passe modifié',
    passwordUpdated: 'Votre mot de passe a été mis à jour avec succès.',
    incorrectPassword: 'Mot de passe incorrect',
    passwordDoesNotMatch: 'Le mot de passe ne correspond pas. Veuillez réessayer.',
    close: 'Fermer',
    emailSentTo: "L'email a été envoyé à",
    withLinkTo: 'avec un lien pour réinitialiser votre mot de passe.',
    reset: 'Réinitialiser',
    passwordResetEmailSent: 'Nous avons envoyé des instructions pour réinitialiser le mot de passe à votre adresse email',
    passwordResetEmailNotSent: "Nous n'avons pas pu envoyer les instructions pour réinitialiser le mot de passe",
    resetPasswordNote: "Remarque : Si nous trouvons le compte associé à l'adresse e- mail, vous recevrez un code pour terminer la réinitialisation de votre mot de passe.",
    backTo: "Retour à",
    resetPasswordRules: 'Votre mot de passe doit comporter au moins 8 caractères et inclure une combinaison de lettres, de chiffres et de caractères spéciaux.',
    /**
     * Enrollment page
     */
    wallet: 'Portefeuille',
    walletActivationFail: "Échec de l'activation du portefeuille.",
    walletActivationFailMessage: 'Un problème est survenu. Veuillez réessayer ultérieurement.',
    walletImportSuccess: 'Importation du portefeuille réussie',
    walletImportSuccessMsg: 'Votre portefeuille a été importé avec succès.',
    walletNotActivated: 'Portefeuille non activé, réessayez',
    important: 'Important !',
    walletInfo: 'Votre portefeuille a été activé. Veuillez sauvegarder votre portefeuille et le conserver en toute sécurité.',
    ok: 'Ok',
    finish: 'Terminer',
    activationSuccessful: 'Activation réussie',
    importCertificate: 'Importer le certificat',
    activate: 'Activer',
    reactivate: 'Réactiver',
    activateYourWallet: 'Activer votre portefeuille',
    reactivateYourWallet: 'Réactiver votre portefeuille',
    import: 'Importer',
    walletImportFail: "Échec de l'importation du portefeuille",
    tryWalletImportAgain: "Veuillez vérifier le fichier que vous avez sélectionné pour l'importation et réessayer.",
    yourWalletActivated: 'Votre portefeuille a été activé avec succès.',
    youWalletActivatedDescription: "Veuillez garder votre portefeuille sécurisé. Ne le partagez pas avec d'autres personnes car cela représente votre identité blockchain. Nous vous recommandons de sauvegarder votre portefeuille au cas où vous perdriez ou changeriez votre appareil.",
    activateWalletDescription: "Pour accéder à vos billets, vous devez d'abord activer votre portefeuille. L'activation de votre portefeuille émet un certificat qui prouve votre propriété du billet.",
    reactivateWalletDescription: "Pour accéder à vos billets, vous devez d'abord réactiver votre portefeuille. La réactivation de votre portefeuille émet un certificat qui prouve votre propriété du billet.",
    beSureToBackUp: "Assurez-vous de sauvegarder votre portefeuille après l'activation.",
    beSureToReBackUp: 'Assurez-vous de sauvegarder votre portefeuille après la réactivation.',
    youAlreadyActivatedWallet: 'Vous avez déjà activé votre portefeuille. Pour accéder à vos billets, vous devrez importer votre certificat.',
    importWalletAccessTickets: "Importez votre portefeuille afin d'accéder à tous les billets achetés",
    almostDoneImportingWallet: 'Vous avez presque terminé ! Importation de votre portefeuille',
    almostDoneActivatingWallet: 'Vous avez presque terminé ! Activation de votre portefeuille',
    almostDoneReactivatingWallet: 'Vous avez presque terminé ! Réactivation de votre portefeuille',
    didNotBackUpWallet: "Si vous n'avez pas sauvegardé votre certificat, ou si vous avez perdu votre téléphone, contactez le support @BAMSupport.",
    /**
     * Menu
     */
    myProfile: 'Mon profil',
    save: 'Enregistrer',
    organizer: 'Organisateur',
    signout: 'Déconnexion',
    signoutTitle: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    signoutMessage: "Assurez-vous d'avoir enregistré toutes les modifications que vous avez apportées avant de vous déconnecter.",
    applicationSettings: "Paramètres de l'application",
    support: 'Support',
    /**
     * Profile page
     */
    account: 'Compte',
    personalInformation: 'Informations personnelles',
    informationUpdated: 'Informations mises à jour avec succès !',
    invalidEmail: 'Une adresse e-mail valide est requise',
    chooseOption: 'Choisir une option',
    cancel: 'Annuler',
    galleryImages: 'Images de la galerie',
    profilePicture: 'Image de profil',
    imageNotUploaded: 'Image non téléchargée !',
    useCamera: "Utiliser l'appareil photo",
    removeAccountError: 'Impossible de supprimer le compte, réessayez.',
    removeAccountSure: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    removeAccountInfo: 'En supprimant votre compte, vous perdrez tous les billets que vous possédez actuellement.',
    removeAccount: 'Supprimer le compte',
    personalData: 'DONNÉES PERSONNELLES',
    atLeastThreeCharacters: 'Au moins 3 caractères',
    firstname: 'Prénom',
    lastname: 'Nom de famille',
    email: 'E-mail',
    dateOfBirthday: 'Date de naissance (facultatif)',
    phone: 'Téléphone (facultatif)',
    address: 'Adresse',
    city: 'Ville',
    state: 'État',
    country: 'Pays',
    location: 'EMPLACEMENT',
    paypalAccount: 'Paypal Account',
    /**
     * Organizer publish page
     */
    transaction: 'Transaction',
    transactionPublished: 'Transaction publiée avec succès',
    transactionNotPublished: 'Impossible de publier la transaction',
    transactionProcessing: "La transaction est en cours de traitement, veuillez patienter s'il vous plaît!",
    /**
     * Register page
     */
    invalidPassword: 'Le mot de passe doit comporter au moins 8 caractères, y compris au moins une lettre minuscule, une lettre majuscule et un chiffre.',
    invalidUsername: "Les noms d'utilisateur doivent comporter au moins 3 caractères et peuvent contenir des lettres majuscules et minuscules de l'alphabet latin, des chiffres, des tirets et des underscores",
    letsGetOnBoard: "Montons à bord !",
    enterValidUsername: "Saisissez un nom d'utilisateur valide * ",
    enterValidFirstname: 'Saisissez un prénom valide *',
    enterValidLastname: 'Saisissez un nom de famille valide *',
    enterValidEmail: 'Saisissez une adresse e-mail valide *',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    /**
     * Tickets overview page
     */
    start: 'Commencer',
    seating: 'Places',
    date: 'date',
    edit: 'Modifier',
    ticketInvalidated: 'Ce billet a déjà été scanné et utilisé.',
    dateOfSale: 'Date de vente',
    price: 'Prix',
    expirationDate: "Date d'expiration",
    removeFromMarketPlace: 'Retirer du Marketplace',
    activateConfirmTitle: 'Êtes-vous sûr de vouloir activer ce billet ?',
    activateConfirmText: "Une fois activé, vous ne pourrez plus le désactiver, le transférer ou le vendre.",
    activateTicket: 'Activer le billet',
    ticketIsProcessed: "Votre billet est en cours de traitement - une fois émis, vous pourrez le transférer, le vendre et l'activer.",
    moreInfo: "Plus d'informations",
    swipeEventDetails: "Faites glisser pour plus de détails sur l'événement",
    /**
     * Single Ticket screen
     */
    qrCode: 'Code QR',
    ticketCantActivate: "Le code QR du billet reste verrouillé jusqu'à sept jours avant l'événement.",
    ticketActivateFirst: "Pour afficher le code QR, le billet doit d'abord être activé.",
    ticketCantActivateEnded: "Vous ne pouvez pas activer le billet après la date de l'événement.",
    showQrCodeAtEntrance: "Montrez le code QR à l'entrée pour accéder à l'événement.",
    options: 'Options',
    transferTicketsToFriends: 'Transférez des billets à vos amis gratuitement ou vendez-les sur notre marché secondaire sécurisé.',
    ticket: 'Billet',
    discount: 'Remise',
    dateAndLocation: 'Date et Lieu',
    ticketHolder: 'Détenteur du billet',
    ticketDetails: 'Détails du billet',
    readMore: 'Lire plus',
    eventDetails: "Détails de l'événement",
    buyTickets: 'Acheter des billets',
    detailsAboutTicket: 'Détails sur le billet',
    detailsAboutEvent: 'Détails sur cet événement',
    /**
   * Form input component
   */
    gender: 'Genre (Facultatif)',
    male: 'Homme',
    female: 'Femme',
    other: 'Autre',
    /**
     * Wallet page
     */
    exportShareMessage: 'Sauvegardez votre portefeuille dans un espace sécurisé :',
    backupWallet: 'Sauvegarder le portefeuille',
    backup: 'Sauvegarde',
    backupText: "Vous n'avez pas encore sauvegardé votre portefeuille, veuillez créer une sauvegarde au cas où vous auriez besoin de récupérer votre portefeuille.",
    backupIncomplete: 'Sauvegarde incomplète',
    backupComplete: 'Sauvegarde terminée',
    backupSuccessTitle: 'Votre portefeuille a été sauvegardé avec succès.',
    backupSuccessInfo: "Veuillez conserver votre portefeuille en sécurité. Ne le partagez pas avec d'autres personnes car il représente votre identité blockchain.",
    permissionDenied: 'Autorisation refusée, réessayez',
    shareMessage: 'Partageons quelques tickets ! Voici mon ',
    copied: 'Copié',
    add: 'Ajouter',
    connectedWallets: 'Portefeuilles connectés',
    connectYourWallet: 'Connectez votre portefeuille',
    connectYourWalletInfo: "Si vous n'avez pas encore de portefeuille, vous pouvez sélectionner un fournisseur, télécharger l'application et en créer un maintenant.",
    metamask: 'Metamask',
    to: 'à',
    the: 'le',
    downloads: 'téléchargements',
    folder: 'dossier',
    /**
     * Offline page
     */
    offlineHeader: 'Hors ligne',
    offlineText: 'Vous êtes actuellement hors ligne.',
    offlineSecondText: 'Certaines fonctions peuvent ne pas être disponibles.',
    /**
     * Home page
     */
    tickets: 'Billets',
    pastExperience: 'Expériences passées',
    upcoming: 'À venir',
    noTickets: "Vous n'avez pas encore de billets.",
    checkOutOur: 'Découvrez notre ',
    ticketMarketplace: 'Place de marché des billets',
    toGetThem: ' pour les obtenir.',
    /**
     * Transfer page
     */
    transferTicket: 'Transférer les billets',
    transferTicketDescription: "Scannez un code QR ou saisissez l'identifiant de portefeuille du destinataire pour sélectionner et transférer les billets.",
    bamWalletShareTitleStart: "Votre ami n'a pas encore l'application ",
    bamWalletShareTitleEnd: ' ? ',
    bamWalletShareSubTitleStart: "Invitez vos amis et partagez l'application ",
    bamWalletShareSubTitleEnd: ' avec eux pour faciliter le transfert des billets.',
    enterWalletId: 'Identifiant du portefeuille du destinataire',
    walletIdError: 'Utilisateur introuvable / Identifiant incomplet',
    share: 'Partager',
    transfer: 'Transférer',
    sell: 'Vendre',
    sellTicket: 'Vendre un billet',
    walletId: 'Identifiant du portefeuille',
    transferModalSbtitle: 'Une fois transférés, les billets seront retirés de votre portefeuille.',
    shareModalTitleStart: 'Partager ',
    shareModalTitleEnd: ' avec un ami',
    succesTransferMessageTile: 'Billet(s) transféré(s)',
    errorTransferMessageTile: 'Échec du transfert du/des billet(s)',
    succesTransferMessage: 'Votre/vos billet(s) a/ont été transféré(s) avec succès. Ils ne sont plus disponibles dans votre portefeuille.',
    errorTransferMessage: "Une erreur s'est produite.Veuillez réessayer ultérieurement.",
    done: 'Terminé',
    areYouSureTransfer: 'Voulez-vous vraiment transférer',
    ticketsTo: 'billet(s) à',
    tryAgain: 'Réessayer',
    findUser: 'Trouver un utilisateur',
    emailOrWalletId: 'E-mail ou ID de portefeuille',
    emailDoesNotExist: "Nous ne pouvons pas trouver un utilisateur avec cet e-mail. Vérifiez l'e-mail ou appuyez sur 'Inviter' pour inviter l'utilisateur et transférer des billets.",
    invite: 'Inviter',
    selectTicketsToTransfer: 'Sélectionnez les billets à transférer à : ',
    transferring: 'Transfert en cours de ',
    transferringTickets: ' billet(s).',
    okay: "D'accord",
    sureCancelTransferTo: 'Êtes-vous sûr de vouloir annuler le transfert à ',
    ifYouCancelNowRepeatLater: 'Si vous annulez maintenant le processus de transfert, vous pourrez le répéter plus tard.',
    cancelTransfer: 'Annuler le transfert',
    backToTickets: 'Retour aux billets',
    successSentInvite: 'Vous avez envoyé avec succès une invitation à un utilisateur.',
    ableToTransferTicketsNow: "Vous pourrez transférer le(s) billet(s) à l'utilisateur maintenant.",
    /**
     * Qrcode Scanner
     */
    qrcodeScannerScreenTitle: 'Scanner le portefeuille',
    scanWallet: 'Scanner le portefeuille',
    /**
     * Ticket holder information
     */
    cancelSureTitle: 'Êtes-vous sûr de vouloir annuler ?',
    cancelSureText: "Assurez-vous d'avoir enregistré toutes les modifications avant de quitter le processus.",
    confirm: 'Confirmer',
    /**
     * Sell ticket
     */
    sellTickets: 'Vendre des billets',
    setExpiration: "Définir la date d'expiration",
    ticketPrice: 'Prix du billet',
    sellTicketConfirmTitle: 'Êtes-vous sûr de vouloir vendre votre billet sur le marché secondaire ?',
    sellTicketConfirmMessage: 'Vous pourrez accéder au(x) billet(s) depuis votre portefeuille et annuler la vente.',
    succesSellTile: 'Billet(s) publié(s) sur le marché',
    succesSellMessage: 'Votre/vos billet(s) a/ont été publié(s) avec succès sur le marché secondaire.',
    errorSellTitle: 'Erreur lors de la vente du billet',
    errorSellMessage: 'Une erreur s\'est produite lors de la tentative de publication de votre billet en vente. Veuillez réessayer.',
    sellFeeHintStart: "L'organisateur prend une commission de",
    sellFeeHintMiddle: '% sur la vente de cet événement. Vous recevrez',
    sellNoFeeHint: "L'organisateur ne prend pas de commission sur la vente de cet événement. Vous recevrez",
    setExpirationDate: 'Définir la date d\'expiration',
    payout: 'Paiement',
    payoutHintText1: 'Veuillez fournir un compte PayPal ou une adresse e-mail qui sera utilisé pour le paiement.',
    payoutHintText2: 'Les paiements se font automatiquement via PayPal une fois que votre billet est vendu. Vous recevrez une notification par e-mail après que la vente ait été traitée.',
    payoutHintText3: 'Merci d\'utiliser notre plateforme ! Si vous avez des questions, contactez notre équipe de support.',
    publishingTicketToSecondaryMarket: 'Publication de votre(s) billet(s) sur le marché secondaire.',
    /**
     * Bottom menu
     */
    nft: 'NFT',
    profile: 'Profil',
    /**
     * NFT screen
     */
    myCollection: 'Ma Collection',
    noNFTsYet: 'Pas encore de NFT',
    doNotSeeNFT: 'Vous ne voyez pas votre NFT ?',
    importNFTs: 'Importer des NFT',
    description: 'Description',
    chain: 'Chaîne',
    /**
     * Metamask wallets screen
     */
    selectWallet: 'Sélectionner un Portefeuille',
    connectedAddresses: 'Adresses Connectées',
    confirmRemoveWalletTitle: 'Voulez-vous vraiment supprimer cette adresse ?',
    confirmRemoveWalletText: 'Si vous supprimez cette adresse, tous vos NFT connectés seront également supprimés.',
    removeAddress: "Supprimer l'Adresse",
    /**
     * Metamask add component
     */
    metamaskWalletConnectSuccessTitle: 'Portefeuille Metamask connecté.',
    metamaskWalletConnectSuccessText: 'Votre portefeuille Metamask a été ajouté avec succès.',
    metamaskWalletConnectErrorTitle: 'Erreur de portefeuille Metamask.',
    metamaskWalletConnectErrorText: "Impossible d'ajouter le portefeuille depuis Metamask.",
    /**
     * App screen
     */
    applicationUpdateTitle: "Mise à jour de l'application requise.",
    applicationUpdateText: "Une nouvelle version de l'application est disponible et est nécessaire pour continuer.Veuillez cliquer ci - dessous pour mettre à jour vers la dernière version.",
    update: 'Mettre à jour',
    understand: "J'ai compris",
    /**
     * Settings
     */
    settings: 'Paramètres',
    notifications: 'Notifications',
    enableNotifications: 'Activer les notifications',
    eventStart: "Début de l'événement",
    checkIn: 'Enregistrement',
    none: 'Aucune',
    minutes: 'minutes',
    hour: 'heure',
    fiveMinutesBefore: '5 minutes avant',
    tenMinutesBefore: '10 minutes avant',
    fifteenMinutesBefore: '15 minutes avant',
    thirtyMinutesBefore: '30 minutes avant',
    fourtyFiveMinutesBefore: '45 minutes avant',
    oneHourBefore: '1 heure avant',
    fiveMinutes: '5 minutes',
    tenMinutes: '10 minutes',
    fifteenMinutes: '15 minutes',
    thirtyMinutes: '30 minutes',
    fourtyFiveMinutes: '45 minutes',
    oneHour: '1 heure',
    language: 'Langue',
    bs: 'Bosnien',
    de: 'Allemand',
    en: 'Anglais',
    es: 'Espagnol',
    fr: 'Français',
    sr: 'Serbe',
    this: 'Ceci',
    is: 'est',
    near: 'proche',
    /**
     * Notifications
     */
    today: "Aujourd'hui",
    clear: 'Effacer',
    noNewNotifications: 'Pas de nouvelles notifications',
    noNewNotificationsHint: 'Vous êtes à jour ! Revenez plus tard pour de nouvelles notifications.',
    /**
     * Validator App
     */
    /**
     * Login screen
     */
    welcome: 'Welcome',
    scanQrCodeHint: 'Use the QR code shown in your organizer dashboard to login.',
    scanQrCode: 'Scan QR code',
    switchedEnvironment: 'Switched Environment',
    switchedEnvironmentToProd: 'Switched environment to prod',
    switchedEnvironmentToDev: 'Switched environment to dev',
    appVersion: 'App Version',
    /**
     * Login-Scan screen
     */
    qrCodeScannerHint: 'Please scan the organizer QR code to login.',
    loginQrErrorTitle: 'Login failed.',
    loginQrError: 'Please use the correct organiser QR code from the admin dashboard.',
    loginLoading: "Almost done. Please don't exit the application until information is loaded.",
    /**
     * Ticket-Scan screen
     */
    tapToStartScanning: 'Tap to start scanning',
    validTicket: 'Check-In successful!',
    invalidTicket: 'Invalid Ticket!',
    scannedAt: 'Scanned at',
    venueInfoError: 'Unable to fetch venue information',
    signingKeyError: 'Unable to fetch signing key',
    eventInfoError: 'Unable to fetch event information',
    ticketQrError: 'Unable to scan QR-Code',
    scanTickets: 'Scan Tickets',
    ticketCountError: 'Unable to fetch amount of scanned tickets',
    scanAgain: 'Scan again',
    signOutTitle: 'Are you sure you want to Sign Out?',
    signOutText: 'Make sure you saved all the changes you made before signing out.',
    logout: 'Logout',
    checkedIn: 'Checked-in:',
    of: 'of',
    validatingTicket: 'Validating ticket.',
};
//# sourceMappingURL=fr.js.map